import { Box, InputAdornment, MenuItem, Stack, TextField } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getCurrencySymbol } from "../format-utils"

export function CurrencyAndRate() {
    const { target, refresh } = useBoundContext()
    const symbol = getCurrencySymbol(target.currency || "GBP")

    return (
        <Stack direction="row" spacing={2}>
            <Box sx={{ flex: 1 }}>
                <TextField
                    select
                    label="Currency"
                    value={target.currency || "GBP"}
                    onChange={handleCurrencyChange}
                    fullWidth
                >
                    <MenuItem value="GBP">GBP (£)</MenuItem>
                    <MenuItem value="USD">USD ($)</MenuItem>
                    <MenuItem value="EUR">EUR (€)</MenuItem>
                </TextField>
            </Box>
            <Box sx={{ flex: 1 }}>
                <TextField
                    data-cy="default-hourly-rate"
                    label="Default Hourly Rate"
                    type="number"
                    value={target.defaultRate ?? ""}
                    onChange={handleDefaultRateChange}
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    inputProps={{ min: 0, step: 0.01 }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">{symbol}</InputAdornment>,
                    }}
                    placeholder="0.00"
                />
            </Box>
        </Stack>
    )

    function handleCurrencyChange(e) {
        target.currency = e.target.value
        refresh()
    }

    function handleDefaultRateChange(e) {
        const parsed = parseFloat(e.target.value)
        target.defaultRate = Number.isNaN(parsed) ? null : parsed
        refresh()
    }
}
